import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS, COUNTRY_FRANCE_ID, ERROR_MESSAGES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import InfoAddressInputTemplate, { InfoAddressInputTemplateFormData } from "../../../components/info-perso-template/InfoAddressInputTemplate";
import GeneralDataProtectionBloc from "../../common/GeneralDataProtectionBloc";

export default function REInfoAddressBloc() {

  const navigate = useNavigate();
  const {
    state: { updatedProposition, proposition},
    dispatch
  } = useAppState();

  const validationSchema = Yup.object().shape({
      address: Yup.string().required(ERROR_MESSAGES.requiredMsg).max(38),
      postalCode: Yup.string()
        .when('countryId', {
        is: (val: any) => val === COUNTRY_FRANCE_ID,
        then: Yup.string()
        .required(ERROR_MESSAGES.requiredMsg)
        .matches(/^[0-9]+$/, ERROR_MESSAGES.invalidMsg )
        .min(5, ERROR_MESSAGES.invalidMsg)
        .max(5, ERROR_MESSAGES.invalidMsg)
        })
        .when('countryId', {
        is: (val: any) => val !== COUNTRY_FRANCE_ID,
        then: Yup.string()
        .required(ERROR_MESSAGES.requiredMsg)
        .matches(/^[a-zA-Z0-9-]+$/, ERROR_MESSAGES.invalidMsg )
        .min(4, ERROR_MESSAGES.invalidMsg)
        .max(8, ERROR_MESSAGES.invalidMsg)
      }),
      city: Yup.string()
        .required(ERROR_MESSAGES.requiredMsg)
        .max(38, ERROR_MESSAGES.invalidMsg),
      countryId:Yup.string().required(ERROR_MESSAGES.requiredMsg),
      lieudit: Yup.string().max(38),
      buildingName: Yup.string().max(38),
      additionalAddress: Yup.string().max(38),
    });

  const {
    register, setValue, watch,
    handleSubmit,
    formState: { errors },
  } = useForm<InfoAddressInputTemplateFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      address: updatedProposition?.address ? updatedProposition?.address : '',
      postalCode: updatedProposition?.postalCode ? updatedProposition?.postalCode : '',
      city: updatedProposition?.city ? updatedProposition?.city : '',
      countryId: updatedProposition?.countryId ? updatedProposition?.countryId : '',
      lieudit: updatedProposition?.lieudit ? updatedProposition?.lieudit : '',
      additionalAddress: updatedProposition?.additionalAddress ? updatedProposition?.additionalAddress : '',
      buildingName: updatedProposition?.buildingName ? updatedProposition?.buildingName : ''

    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = async (data: InfoAddressInputTemplateFormData) => {
     let tempUpdatedPropo = updatedProposition;
        if(tempUpdatedPropo) {
          tempUpdatedPropo.address = data.address;
          tempUpdatedPropo.postalCode = data.postalCode;
          tempUpdatedPropo.city = data.city;
          tempUpdatedPropo.countryId = data.countryId;
          tempUpdatedPropo.lieudit = data.lieudit;
          tempUpdatedPropo.additionalAddress = data.additionalAddress;
          tempUpdatedPropo.buildingName = data.buildingName;
        }  
    const nextUrl = APP_RETIREMENT_URLS.infoContactPage;
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
    navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.infoIdentityPage
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });         
  }


  return (
    <form style={{width: '100%'}}>
      <div className='form-row page-content'>  
        <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
          <InfoAddressInputTemplate 
            register={register} 
            watch={watch} 
            errors={errors} 
            setValue={setValue}
            globalSave={true}
            currentStep={APP_RETIREMENT_URLS.infoAddressPage}
            />
        </div>
      </div>
      <StickButtonsBloc 
          showPreviousButton={true} 
          disabledPreviousButton={false} 
          nextAction={handleSubmit(onNextAction)} 
          showNextButton={true} 
          previousAction={onPreviousAction}
       />
       <GeneralDataProtectionBloc/>
    </form>
  )
}